<template>
  <div class="left-bar-wrap">
    <ul class="left-bar-lists">
      <li class="lists-item" @click="openNewWindow('index.html')"><i class="iconfont icon-yizhangtu"></i> <span>检测预警一张图</span></li>
      <router-link class="lists-item link-item" to="/home"><i class="iconfont icon-liyong"></i>
        <span>耕地利用大数据</span>
        <ul class="sub-item">
          <router-link class="items" to="/home/quality">耕地质量</router-link>
          <router-link class="items" to="/home/transaction">土地流转</router-link>
        </ul>
      </router-link>
      <router-link class="lists-item" to="/pollute">
        <i class="iconfont icon-xuqinwuranchulidashuju"></i>
        <span>畜禽污染处理大数据</span>
        </router-link>
      <li class="lists-item" @click="openNewWindow('quality.html')"><i class="iconfont icon-anquan"></i> <span>农产品质量安全</span></li>
      <li class="lists-item" @click="openNewWindow('price.html')"><i class="iconfont icon-jiage"></i> <span>农产品价格</span></li>
      <li class="lists-item" @click="openNewWindow('sadBalance.html')"><i class="iconfont icon-pingheng"></i> <span>农产品供需平衡</span></li>
      <li class="lists-item" @click="openNewWindow('meteorological.html')"><i class="iconfont icon-qixiang"></i> <span>农业气象</span></li>
      <li class="lists-item" @click="openNewWindow('keyProduct.html')"><i class="iconfont icon-yujing"></i> <span>重要农产品生产检测预警</span></li>
    </ul>
  </div>
</template>

<script>
  import {baseIP} from '../../src/api/config';
  export default {
    name: 'left-bar',
    data() {
      return {
        // baseIP
      }
    },
    methods: {
      openNewWindow(url) {
        // let baseUrl = `${baseIP}/yingtan/dist/html/`
        let baseUrl = `yingtan/dist/html/`
        window.location.href = baseUrl+url
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/css/lib-variable";
  @import "../assets/css/lib-mixin";
  .left-bar-wrap {
    width: 95px;
    padding: 20px 0 0 20px;
    a {
      color: #fff;
    }
    .left-bar-lists {
      color: #fff;
      font-size: $fz-sr;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .lists-item {
        text-align: center;
        cursor: pointer;
        width: 100%;
        height: 85px;
        box-sizing: border-box;
        border-bottom: 1px #006962 solid;
        background-color: #0e413f;
        padding-top: 10px;
        margin-bottom: 1px;
        @include animate();
        &:hover {
          background: radial-gradient(farthest-corner at 50% 10%, #39b6ac, #187276);
        }
        &:nth-last-child(1) {
          height: 100px;
        }
        &:nth-child(3) {
          color: #fff;
          height: 100px;
        }
        .iconfont {
          display: block;
          font-size: 30px;
        }
      }
      > .active {
        background: radial-gradient(farthest-corner at 50% 10%, #39b6ac, #187276);
      }
      .link-item {
        color: #fff;
        position: relative;
        @include animate();
        .sub-item {
          width: 0;
          height: 85px;
          padding: 13px 0 12px 0;
          box-sizing: border-box;
          background-color: #0e413f;
          position: absolute;
          top: 0;
          right: -95px;
          z-index: 100;
          display: none;
          @include animate();
          .active, :hover {
            color: yellow;
          }
          .items {
            display: block;
            height: 30px;
            line-height: 30px;
          }
        }
        &:hover, &:focus {
          .sub-item {
            display: block;
            width: 95px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/leftBar.vue